import React, { useEffect } from "react";
import { AMWAY_CLICK_DEEPLINK } from "../../common/commonConstant";
import { useLocation } from "react-router-dom";

const AmwayClickDeeplink = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    useEffect(() => {
        const deepLinkUrl = params.get('deepLinkUrl') || AMWAY_CLICK_DEEPLINK;
        window.location = new URL(deepLinkUrl)
    }, [])
    return <></>
}

export default AmwayClickDeeplink;